import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, ControlLabel, FormGroup, Row } from 'react-bootstrap';
import { Form, actions } from 'react-redux-form';
import Divider from '../common/divider';
import ArrowButton from '../common/button-arrow';
import { getTransferValue, saveTransferPoints } from '../../actions/reward';
import RequiredSelect from '../common/form/elements/required-select';
import RequiredInput from '../common/form/elements/required-input';
import ConfirmPopup from '../common/confirm-popup';

const model = 'deep.points_transfer';

class MyRewardsStaffMembers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isConfirmDialogActive: false
    }
  }

  handleSubmit = (payload) => {
    const { dispatch } = this.props;

    dispatch(actions.submitFields(model, saveTransferPoints(payload, this.props.pointValue))).then(() => {
      const { individualRewards, setNextOrderAmount } = this.props;
      const { next_order_amount, individual_balance } = individualRewards.order;

      if (individualRewards.order && next_order_amount && individual_balance) {
        setNextOrderAmount(next_order_amount, individual_balance);
      }

      dispatch(actions.reset(model));
    });
  };

  handleOpenConfirmDialog = () => {
    const { payload, dispatch } = this.props;

    dispatch(getTransferValue(payload.euro)).then(() => {
      this.setState({ isConfirmDialogActive: true });
    });
  }

  handleCloseConfirmDialog = (result) => {
    if (result) {
      const { payload } = this.props;

      this.handleSubmit(payload);
    }

    this.setState({ isConfirmDialogActive: false });
  }

  staffMemberName = () => {
    const { payload, staffMembers } = this.props;
    const staffMember = staffMembers.find((staffMember) => staffMember.id === +payload.staff_member);

    if (staffMember) {
      return `${staffMember.first_name} ${staffMember.last_name}`;
    }

    return '';
  }

  render() {
    const { formValid, payload, pointValue, staffMembers } = this.props;
    const { isConfirmDialogActive } = this.state;
    const data = staffMembers.map((staffMember) => ({
      value: `${staffMember.id}`,
      label: `${staffMember.first_name} ${staffMember.last_name}`
    }));

    return(
      <div>
        <Form model={model} onSubmit={this.handleOpenConfirmDialog}>
          <Divider />
          <h3>
            Points Transfer
          </h3>
          <Row>
            <Col md={6}>
              <FormGroup>
                <ControlLabel>Staff member</ControlLabel>
                  <RequiredSelect
                    model={`${model}.staff_member`}
                    values={data} />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
              <ControlLabel>Euro</ControlLabel>
                <RequiredInput
                  model=".euro"
                  type='number'
                  min={1} />
              </FormGroup>
            </Col>
            <Col md={3}>
              <ArrowButton arrow={false} className="transfer-points-button" disabled={!formValid}>
                Transfer Points
              </ArrowButton>
            </Col>
          </Row>
        </Form>
        {isConfirmDialogActive &&
          <ConfirmPopup
            header="Points Transfer"
            onClose={this.handleCloseConfirmDialog}>
            <p>Are you sure you want to transfer <b>{payload.euro}</b> euro (<b>{pointValue}</b> points) to <b>{this.staffMemberName()}</b>?</p>
          </ConfirmPopup>}
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  formValid: state.deep.forms.points_transfer.$form.valid,
  payload: state.deep.points_transfer,
  individualRewards: state.rewards.individualRewards,
  pointValue: state.rewards.pointValue
});

export default connect(mapStateToProps)(MyRewardsStaffMembers);



// WEBPACK FOOTER //
// ./src/components/my-rewards/my-rewards-staff-members.jsx